import {
  withStyles,
  WithStyles,
  Typography,
  Theme,
  Fab
  // Tooltip,
} from '@material-ui/core'
import i18n from 'i18next'
import { FC, Fragment, useState, useEffect } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import Talk from 'talkjs'
import {
  selectApplications,
  rejectApplication
} from '../../actions/applications'
import { closeDialog, openDialog } from '../../actions/dialogs'
import { navigate } from '../../actions/routes'
import {
  OpenDialog,
  SelectApplicationsArray,
  RejectApplicationAction,
  Navigate,
  CloseDialog
} from '../../actions/types'
import Container from '../../components/Container'
import GridContainer from '../../components/Grid/GridContainer'
import { objectNotEmpty } from '../../libs/objects'
import { selectApartmentById } from '../../selectors/apartments'
import {
  selectAvailabilitiesByApartment,
  selectAvailabilitiesByApplicationIds
} from '../../selectors/applicantAvailability'
import {
  selectApplicationsByApartmentId,
  getApplicationsGroupedByStatus,
  selectSelectedApplications
} from '../../selectors/applications'
import { selectContentIdFromPathname } from '../../selectors/router'
import { selectShowingsInterfaceByApartmentId } from '../../selectors/showings'
import {
  selectIsAdminUser,
  selectIsMobile,
  selectUserAttributes
} from '../../selectors/users'
import { UserAttributes } from '../../services/auth/types'
import { getCurrentLanguage } from '../../translations/i18n'
import { MuiClasses } from '../../types'
import { Apartment, ApartmentStatus } from '../../types/apartments'
import { ApplicantAvailability } from '../../types/applicantAvailability'
import { Application, ApplicationsByStatus } from '../../types/applications'
import { Showing } from '../../types/showings'
import { EmptyShowingsInterface, StateInterface } from '../../types/states'
import { get, addPopup, getOrCreateConversation } from '../../utils/talkChat'
import Suggest from '../Apartment/Stepper/Steps/Suggest'
import ApplicationCard from './ApplicationCard'
import ApplicationsTabs from './ApplicationsTabs'
import { useHistory } from 'react-router-dom';

interface StateProps {
  isMobile?: boolean
  isAdmin: boolean
  applicationsByStatus?: ApplicationsByStatus
  apartment?: Apartment
  userAttributes: any
  selectedApplicationsFromState: string[]
  availabilities?: ApplicantAvailability[]
  existingShowings?: Showing[]
}
interface DispatchProps {
  openDialog: OpenDialog
  closeDialog: CloseDialog
  selectApplicationsAction: SelectApplicationsArray
  navigateToPath: Navigate
}

interface ApplicationsProps extends WithTranslation {
  classes: MuiClasses
  t: i18n.TFunction
  selectApplicationsAction: SelectApplicationsArray
  rejectApplicationAction: RejectApplicationAction
}

type ComponentProps = ApplicationsProps &
  StateProps &
  DispatchProps &
  WithStyles

const styles = ({ breakpoints, spacing }: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    [breakpoints.down('xs')]: {
      paddingBottom: '45px'
    }
  },
  link: {
    color: 'inherit'
  },
  primaryBtn: {
    backgroundColor: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  applications: {
    paddingTop: '1rem',
    justifyContent: 'center' as const
  },
  subContainer: {
    position: 'relative' as const,
    padding: '0rem 10rem',
    paddingTop: '2rem',
    [breakpoints.down('md')]: {
      padding: '2rem'
    },
    [breakpoints.down('sm')]: {
      padding: '0.5rem',
      paddingTop: '2rem'
    },
    '& .infoIcon': {
      color: '#000',
      position: 'absolute',
      right: '1rem',
      top: '0.25rem',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      '& a': {
        height: '35px',
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit'
      },
      '& svg': {
        height: '35px',
        width: '35px',
        color: '#000',
        textDecoration: 'none'
      }
    }
  },
  inviteButton: {
    alignSelf: 'flex-end'
  },
  message: {
    color: '#707070',
    background: '#E8E8E8',
    boxShadow: '0px 3px 6px rgba(0,0,0,0.16)',
    padding: '3rem',
    fontSize: '20px',
    textAlign: 'center' as const,
    width: '55%',
    position: 'absolute' as const,
    zIndex: 1,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  fabDivBottom: {
    position: 'fixed' as const,
    height: '36px',
    [breakpoints.up('sm')]: {
      bottom: spacing(2),
      right: spacing(3)
    },
    [breakpoints.only('xs')]: {
      display: 'none',

      bottom: spacing(2),
      right: spacing(1)
    }
  },
  applicantsButton: {
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed' as const,
    width: '320px',
    [breakpoints.up('sm')]: {
      top: '85px',
      right: getCurrentLanguage() == 'en' ? '142px' : '163px'
    },
    [breakpoints.up('md')]: {
      top: '85px',
      right: getCurrentLanguage() == 'en' ? '145px' : '167px'
    },
    [breakpoints.up('lg')]: {
      top: '85px',
      right: getCurrentLanguage() == 'en' ? '148px' : '170px'
    },
    [breakpoints.only('xs')]: {
      width: 'calc(100% - 20px)',
      bottom: spacing(2)
    }
  },
  fabDivTop: {
    display: 'none',
    [breakpoints.only('xs')]: {
      display: 'initial',
      maxWidth: '379px',
      margin: '0 8px',
      width: '100%',
      '& > span': {
        width: '100%'
      },
      '& button': {
        height: 'auto !important',
        padding: '6px 16px',
        width: '100%'
      }
    }
  },
  fabDivLeft: {
    marginRight: '7px',
    [breakpoints.only('xs')]: {
      width: '100%',
      '& button': {
        height: 'auto !important',
        width: '100%',
        padding: '6px 16px'
      }
    }
  },
  fabDivLeftTitle: {
    color: '#C3C6D1',
    fontSize: '14px',
    marginLeft: '8px'
  },
  fab: {
    padding: '0 30px',
    height: '36px !important',
    borderRadius: '4px !important',
    background: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  addressTitle: {
    paddingBottom: '15px'
  }
})

const Applications: FC<ComponentProps> = ({
  classes,
  isMobile,
  isAdmin,
  apartment,
  // selectedApplicationsFromState,
  applicationsByStatus,
  availabilities,
  existingShowings,
  openDialog,
  selectApplicationsAction,
  rejectApplicationAction,
  t,
  navigateToPath,
  closeDialog,
  userAttributes
}) => {
  let chatPopup: Talk.Popup
  const [currentTab, setCurrentTab] = useState<
    'received' | 'rejected' | 'accepted' | 'showingReserved'
  >('received')
  const [selectedApplications, setSelectedApplications] = useState<string[]>([])

  const selectApplication = (id: string) => {
    setSelectedApplications(
      selectedApplications.some((currentId: string) => currentId === id)
        ? selectedApplications.filter((currentId: string) => id !== currentId)
        : [...selectedApplications, id]
    )
  }
  const history = useHistory();
  useEffect(() => {
    const tab = history.location.state?.tab;
    if (tab) {
      setCurrentTab(tab);
    }
  }, []);

  if (!apartment || !applicationsByStatus) {
    return <Fragment />
  }

  const {
    created: createdApplications,
    rejected: rejectedApplications,
    accepted: acceptedApplications,
    showingReserved: showingReservedApplications,
    noAvailableTimes: noAvailableTimesApplications,
    wantsContract: wantsContractApplications,
    invitationsSent: invitationsSentApplications,
    tenant: tenantApplications,
  } = applicationsByStatus

  const applicants = [
    ...wantsContractApplications,
    ...invitationsSentApplications,
    ...acceptedApplications,
    ...createdApplications,
    ...showingReservedApplications
  ]

  const viewingApplicants = [
    ...acceptedApplications,
    ...showingReservedApplications,
  ]

  const contractApplicants = [
    ...wantsContractApplications,
    ...invitationsSentApplications,
    ...tenantApplications
  ]

  // const hasNoAvailableTimesApplications =
  //   noAvailableTimesApplications.length > 0
  const tabsProps = {
    setCurrentTab,
    currentTab,
    t,
    isAdmin,
    applicationsByStatus
  }
  const gridContainerProps = {
    className: classes.applications,
    isMobile
  }
  const commonCardProps = {
    openDialog,
    closeDialog,
    t
  }
  const createdAndRejectedCardProps = {
    ...commonCardProps,
    selectApplication,
    rejectApplicationAction
  }

  const allowInvitations =
    apartment.status === ApartmentStatus.marketing ||
    apartment.status === ApartmentStatus.followUp

  /** todo, allow actions in followUp status */
  const disableApplicationActions =
    apartment.status !== ApartmentStatus.marketing &&
    apartment.status !== ApartmentStatus.followUp

  const getApplicationsByTab = (currentTab: string) => {
    console.log('currentTab', currentTab)
    switch (currentTab) {
      case 'received': // Applicants tab
        return [...applicants] 
      case 'rejected': // Rejected tab
        return [...rejectedApplications]
      case 'accepted': // Viewings tab
        return [...viewingApplicants]
      case 'showingReserved':  // Contract
        return [...contractApplicants]
      default:
        return [...applicants] 
    }
  }
  const sortDesc = (applications: Application[]) =>
    applications.sort((a, b) => b.createdAt - a.createdAt)
  /** handle showing creation for single application */

  /** handle showing creation for multiple applications */
  const openSelectedApplicationsPage = () => {
    initiateApplicantsConversation()
    selectApplicationsAction(selectedApplications)
    navigateToPath(`showings`)
  }

  const initiateApplicantsConversation = async () => {
    for (const applicationId of selectedApplications) {
      const application = getApplicationsByTab(currentTab).find(
        (app) => app.applicationId === applicationId
      )
      if (application) await initiateConversation(application)
    }
  }

  const initiateConversation = async (application: Application) => {
    const conversation = await getOrCreateConversation(apartment, application)
    //console.log('application conversation', Object.assign({}, conversation))
    return conversation
  }

  const showChatPopup = async (conversation: any) => {
    const session = await get()
    chatPopup = session.createPopup({
      launcher: 'never',
      showCloseInHeader: true
    })
    chatPopup.select(conversation)
    chatPopup.mount({ show: true })
    addPopup(chatPopup)
  }

  const chatWithApplicant = async (applicationId: string) => {
    const application = getApplicationsByTab(currentTab).find(
      (app) => app.applicationId === applicationId
    )
    if (application) {
      const conversation = await initiateConversation(application)
      await showChatPopup(conversation)
    }
  }

  return (
    <Fragment>
      <Container className={classes.container}>
        <Container className={classes.subContainer}>
          <Typography variant='h5' className={classes.addressTitle}>
            {apartment?.information?.address}
          </Typography>
          <Typography
            variant='h5'
            gutterBottom
            style={{
              marginRight: '1rem',
              width: '100%',
              fontSize: '1.3rem',
              fontWeight: 'normal'
            }}
          >
            {`${t('apartments.status.newApplicants')} (${getApplicationsByTab(currentTab).length
              })`}
          </Typography>
          <ApplicationsTabs {...tabsProps} />
          <GridContainer {...gridContainerProps}>
            {sortDesc(getApplicationsByTab(currentTab)).map((application) => (
              <ApplicationCard
                key={application.applicationId}
                application={application}
                apartment={apartment}
                userAttributes={userAttributes}
                listCase={currentTab}
                disableActions={disableApplicationActions}
                //selectedApplications={selectedApplications}
                chatWithApplicant={chatWithApplicant}
                allowInvitations
                isAdmin={isAdmin}
                isSelected={selectedApplications.some(
                  (applicantId: string) =>
                    applicantId === application.applicationId
                )}
                {...createdAndRejectedCardProps}
                availabilities={
                  availabilities
                    ? selectAvailabilitiesByApplicationIds(availabilities, [
                      application.applicationId
                    ])
                    : undefined
                }
                showings={existingShowings?.filter(
                  (showing) =>
                    showing.applicationIds?.includes(
                      application.applicationId
                    ) ||
                    showing.invitedApplicationIds?.includes(
                      application.applicationId
                    )
                )}
              />
            ))}
            {applicants.length === 0 && currentTab === 'received' && (
              <Typography variant='body1' gutterBottom>
                <Suggest
                  content={<div>
                    {t('application.noApplicantsReceived.part1')}{" "}
                    <a href={t('application.noApplicantsReceived.linkUrl')} style={{ color: "#94004A" }} target="_blank">
                      {t('application.noApplicantsReceived.linkText')}
                    </a>
                    {t('application.noApplicantsReceived.part2')}
                  </div>}
                  //content={t('application.noApplicantsReceived')}
                  containerMaxWidth='850px'
                  contentMaxWidth='650px'
                />
              </Typography>
            )}
          </GridContainer>
          {!(applicants.length === 0 && currentTab === 'received') && (
            <Suggest
              content={t(`applications.hints.${currentTab}`)}
              containerMaxWidth='850px'
              contentMaxWidth='650px'
            />
          )}
        </Container>
        <div className={classes.applicantsButton}>
          <span className={classes.fabDivTop}>
            <Fab
              color='primary'
              variant='extended'
              disabled={selectedApplications.length === 0 || !allowInvitations}
              className={classes.fab}
              onClick={openSelectedApplicationsPage}
            >
              {allowInvitations &&
                `${t('application.inviteApplicants')} (${selectedApplications.length
                })`}
              {!allowInvitations && t('application.inviteDisabled')}
            </Fab>
          </span>
        </div>

        <span className={classes.fabDivBottom}>
          <Fab
            color='primary'
            variant='extended'
            disabled={selectedApplications.length === 0 || !allowInvitations}
            className={classes.fab}
            onClick={openSelectedApplicationsPage}
          >
            {allowInvitations &&
              `${t('application.inviteApplicants')} (${selectedApplications.length
              })`}
            {!allowInvitations && t('application.inviteDisabled')}
          </Fab>
        </span>
      </Container>
    </Fragment>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)

  const showingsInterface = apartmentId
    ? selectShowingsInterfaceByApartmentId(apartmentId)(state)
    : EmptyShowingsInterface

  const stateUserAttributes = selectUserAttributes(state)

  return {
    isMobile: selectIsMobile(state),
    isAdmin: selectIsAdminUser(state),
    apartment: apartmentId
      ? selectApartmentById(apartmentId)(state)
      : undefined,
    userAttributes: objectNotEmpty<UserAttributes>(stateUserAttributes)
      ? stateUserAttributes
      : undefined,
    selectedApplicationsFromState: selectSelectedApplications(state),
    existingShowings: showingsInterface.showings,
    applicationsByStatus: apartmentId
      ? getApplicationsGroupedByStatus(
        selectApplicationsByApartmentId(apartmentId)(state)
      )
      : undefined,
    availabilities: apartmentId
      ? selectAvailabilitiesByApartment(apartmentId)(state)
      : undefined
  }
}
const mapDispatchToProps = (dispatch: Dispatch) => ({
  openDialog: (id: string) => dispatch(openDialog(id)),
  closeDialog: (id: string) => dispatch(closeDialog(id)),
  selectApplicationsAction: (applicationIdArray: string[]) =>
    dispatch(selectApplications(applicationIdArray)),
  rejectApplicationAction: (apartmentId: string, applicationId: string) =>
    dispatch(rejectApplication(apartmentId, applicationId)),
  navigateToPath: (path: string) => dispatch(navigate(path))
})

export default connect<
  StateProps,
  DispatchProps,
  ApplicationsProps,
  StateInterface
>(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Applications)))
